import Tooltip from '@mui/material/Tooltip';
import React from 'react';
import Grid from '@mui/material/Grid';
import ScorecardScoreViewModel from '../Monitoring/ViewModels/ScorecardScoreViewModel';
import ReportIcon from '@mui/icons-material/Report';
import PersonIcon from '@mui/icons-material/Person';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

export default function displayScorecardResult(scoreViewModel: ScorecardScoreViewModel) {
    const score = scoreViewModel.score ? scoreViewModel.score : '';

    let resultIcon;
    switch (scoreViewModel.result) {
        case 'Pass':
            resultIcon = <Tooltip title='Pass'>
                <CheckCircleIcon color='success' sx={{ paddingTop: '3px' }} />
            </Tooltip>
            break;
        case 'Fail':
            resultIcon = <Tooltip title='Fail'>
                <ReportIcon sx={{ color: '#ff9800', paddingTop: '3px' }} />
            </Tooltip>
            break;
        case 'Critical Fail':
            resultIcon = <Tooltip title='Critical Fail'>
                <ReportIcon color='error' sx={{ paddingTop: '3px' }} />
            </Tooltip>
            break
        default:
            resultIcon = '';
    }
    return (
        <Grid container alignItems='center'>
            <Grid size={8}>{score}</Grid>
            <Grid size={2} style={{ textAlignLast: 'right' }}>{resultIcon}</Grid>
            {
                scoreViewModel.result && !scoreViewModel.isAi &&
                <Grid size={2}>
                    <Tooltip title='This feedback was not provided by an AI'>
                        <PersonIcon sx={{ color: '#0277bd', paddingTop: '3px' }} />
                    </Tooltip>
                </Grid>
            }
        </Grid >)
}